const { default: Swiper } = require('swiper');
import { Scrollbar } from 'swiper/modules';

export const handlePromoProducts = () => {
    const sections = document.querySelectorAll('.promo-products');

    if (sections.length) {
        Swiper.use([Scrollbar]);

        sections.forEach(element => {
            const sliderElement = element.querySelector(
                '.js-promo-products-slider'
            );
            const scrollbar = sliderElement.querySelector('.slider-scrollbar');
            const swiper = new Swiper(sliderElement, {
                scrollbar: {
                    el: scrollbar,
                    dragClass: 'slider-scrollbar__drag',
                    draggable: true,
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1.5,
                        spaceBetween: 8,
                    },
                    991.98: {
                        slidesPerView: 4,
                        spaceBetween: 24,
                    },
                },
            });
        });
    }
};

handlePromoProducts();
